import { Spinner } from '@/components/glitch-ui/spinner';
import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { organizationDataAtom } from '@/store';
import { businessQueryOptions } from '@/lib/query-options';

export const Route = createFileRoute('/_authenticated/new/_layout/onboarding/')({
  component: OnboardingRedirect,
});

/**
 * OnboardingRedirect - Redirects users based on brand existence
 *
 * This component replaces the old combined onboarding flow.
 * - If no brand exists: redirect to /new/brand
 * - If brand exists: redirect to /campaigns
 */
function OnboardingRedirect() {
  const navigate = useNavigate();
  const organizationData = useAtomValue(organizationDataAtom);

  const { data: business, isLoading } = useQuery({
    ...businessQueryOptions(organizationData?.id || 0),
    enabled: !!organizationData?.id,
  });

  useEffect(() => {
    if (isLoading) return;

    if (business) {
      // Brand exists, redirect to campaigns
      navigate({ to: '/campaigns', replace: true });
    } else {
      // No brand, redirect to brand creation
      navigate({ to: '/new/brand', replace: true });
    }
  }, [isLoading, business, navigate]);

  // Show loading state while determining redirect
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="xl" className="text-[#290BD9]" />
        <p className="text-gray-700">Loading...</p>
      </div>
    </div>
  );
}
